<script setup lang="ts">
import type { PersonData } from '~/utils/crystallize/pieces'

defineProps<{
  isLoading?: boolean
  author: PersonData | undefined | null
}>()
</script>

<template>
  <div v-if="author?.image?.firstImage || isLoading" class="max-h-20 aspect-square">
    <Skeleton v-if="isLoading" data-author-image class="size-20" />
    <CrystallizeImage v-else-if="author?.image?.firstImage" data-author-image :image="author?.image?.firstImage" hide-caption img-class="size-20 min-w-20 bg-white object-cover object-top" />
    <svg height="0" width="0">
      <defs>
        <clipPath id="decagon">
          <path d="M29.5801 0.541992H49.7646C50.9747 0.541992 52.1543 0.910087 53.1475 1.59473L53.3428 1.73535L69.7783 14.0742C70.7133 14.7761 71.42 15.7364 71.8125 16.834L71.8867 17.0547L78.2158 37.207C78.5581 38.2967 78.5796 39.4606 78.2803 40.5596L78.2168 40.7783L71.8867 60.9443C71.5365 62.06 70.8662 63.0463 69.9619 63.7822L69.7783 63.9258L53.3428 76.2646C52.3107 77.0393 51.0551 77.458 49.7646 77.458H29.5801C28.3702 77.458 27.1913 77.0896 26.1982 76.4053L26.002 76.2646L9.56641 63.9258C8.63147 63.2238 7.92463 62.2637 7.53223 61.166L7.45801 60.9443L1.12793 40.7783C0.785989 39.6888 0.765128 38.5255 1.06445 37.4268L1.12891 37.207L7.45801 17.0547C7.80828 15.9396 8.47794 14.9534 9.38184 14.2178L9.56641 14.0742L26.002 1.73535C27.034 0.960663 28.2896 0.542007 29.5801 0.541992Z" />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<style scoped>
[data-author-image] {
  clip-path: url(#decagon);
}
</style>
